import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .detalhes-nova-cap-title {
    color: #000;

    font-family: 'Inter';
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    margin-bottom: 32px;
  }

  .detalhes-nova-cap-subtitle {
    color: #000;

    font-family: 'Roboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .detalhes-nova-cap-container {
    display: flex;
    flex-wrap: wrap;

    width: 80%;

    margin-top: 16px;
    gap: 24px 30px;
  }
`

export const Subtitles = styled.h2`
  color: #000;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  margin-top: 15px;
  margin-bottom: 0;
`
export const FormDiv = styled.div`
  overflow-x: hidden;
  height: ${window.innerHeight - 290}px;
  width: 100%;
  overflow: scroll;
  ::-webkit-scrollbar {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-track {
    background: white;
    border: 0;
  }
  ::-webkit-scrollbar-thumb {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const Row = styled.div`
  margin: 0;
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
`
